import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

@Component({
	templateUrl: './install.component.html',
	selector: 'mod-install',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class InstallComponent extends TypeCoreComponent<UserDb.IUserItem> {
	readonly showAppStoreInfo = input<boolean>(true);

	protected storeTitle = computed(() => {
		return `Why ${this.originalAppName()} isn't on the App Store or Play Store?`;
	});

	constructor() {
		super();
	}
}
